(function () {
  'use strict';

  var container = document.getElementById('contact-form-container');
  if (!container) return;

  var webhookUrl = (container.dataset.webhookUrl || '').trim();
  var store = container.dataset.store || 'mayuri';
  if (!webhookUrl) return;

  var form = document.getElementById('contact-form');
  var successEl = document.getElementById('contact-form-success');
  var errorEl = document.getElementById('contact-form-error');
  var submitBtn = form ? form.querySelector('[type="submit"]') : null;

  if (!form) return;

  // Filet Shopify : si n8n échoue, on relance un submit NATIF du form (le
  // hCaptcha Shopify n'intercepte que les vrais événements submit — un fetch
  // sur /contact répond 400 « Missing CAPTCHA token »). Le flag laisse alors
  // le submit natif partir sans re-passer par ce handler ; au retour, le
  // banner Liquid form.posted_successfully? affiche le succès.
  var nativeFallback = false;

  // Attend que le hCaptcha Shopify soit bindé sur le form avant de soumettre :
  // un submit sur un form protégé non bindé est avalé (preventDefault) sans suite.
  // Le binding se fait normalement au premier focus de l'utilisateur ; on le
  // (re)déclenche ici au cas où (autofill sans focus, binding encore en vol).
  function whenCaptchaBound(formEl, cb) {
    if (formEl.dataset.hcaptchaBound || formEl.dataset.recaptchaBound) { cb(); return; }
    formEl.dispatchEvent(new Event('focusin', { bubbles: true }));
    var waited = 0;
    var timer = setInterval(function () {
      waited += 200;
      if (formEl.dataset.hcaptchaBound || formEl.dataset.recaptchaBound || waited >= 5000) {
        clearInterval(timer);
        cb();
      }
    }, 200);
  }

  // Écoute en capture sur document : passe avant le listener submit que le
  // hCaptcha Shopify pose sur le form une fois bindé, qui ignore preventDefault
  // et soumet en natif dès qu'il a son jeton (chaque envoi partait en double,
  // n8n + notification Shopify). stopImmediatePropagation l'en empêche ; en
  // filet (nativeFallback), on le laisse faire son travail.
  document.addEventListener('submit', function (e) {
    if (e.target !== form || nativeFallback) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    hideMessages();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    // Honeypot check — bots fill this hidden field, humans don't
    var honeypot = form.querySelector('[name="contact[website]"]');
    if (honeypot && honeypot.value) {
      showSuccess(); // Fake success so bot thinks it worked
      return;
    }

    setLoading(true);

    // Extract field values
    var nameEl = form.querySelector('[name="contact[name]"]');
    var emailEl = form.querySelector('[name="contact[email]"]');
    var bodyEl = form.querySelector('[name="contact[body]"]');

    var name = nameEl ? nameEl.value.trim() : '';
    var email = emailEl ? emailEl.value.trim() : '';
    var message = bodyEl ? bodyEl.value.trim() : '';

    // Collect custom block fields
    var customFields = {};
    form.querySelectorAll('[name^="contact["]').forEach(function (el) {
      var match = el.name.match(/^contact\[(.+)\]$/);
      if (match) {
        var key = match[1];
        if (key !== 'name' && key !== 'email' && key !== 'body' && key !== 'form_type' && key !== 'utf8' && key !== 'website') {
          customFields[key] = el.value.trim();
        }
      }
    });

    // POST to n8n webhook
    var payload = {
      name: name,
      email: email,
      message: message,
      page_url: window.location.href,
      locale: document.documentElement.lang || 'fr',
      store: store
    };

    if (Object.keys(customFields).length > 0) {
      payload.custom_fields = customFields;
    }
    // origine d'acquisition (journal first-party du snippet myr-attribution), pour l'attribution des demandes
    var myr = typeof window.myrAttribution === 'function' ? window.myrAttribution() : '';
    if (myr) payload.myr_attribution = myr;

    fetch(webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Server error: ' + res.status);
        return res.json().catch(function () { return {}; });
      })
      .then(function () {
        showSuccess();
      })
      .catch(function () {
        // n8n en échec → filet Shopify en soumission native (la page recharge)
        whenCaptchaBound(form, function () {
          nativeFallback = true;
          if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
        });
      });
  }, true);

  function showSuccess() {
    setLoading(false);
    form.style.display = 'none';
    successEl.style.display = 'block';
    window.scrollTo({ top: container.offsetTop - 100, behavior: 'smooth' });
  }

  function setLoading(on) {
    if (submitBtn) {
      submitBtn.style.opacity = on ? '0.6' : '';
      submitBtn.style.pointerEvents = on ? 'none' : '';
    }
  }

  function hideMessages() {
    successEl.style.display = 'none';
    errorEl.style.display = 'none';
  }
})();
